
import PartnerLogo from "@/components/PartnerLogo";
import { usePartners } from "@/hooks/usePartners";

const PartnersGrid = () => {
  const { partners, loading, error } = usePartners();

  return (
    <section className="w-full py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-teedee-blue mb-6">Meet Our Partners</h2>
          <p className="text-xl lg:text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Incredible organizations making a difference in education and community development.
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-teedee-blue mx-auto"></div>
            <p className="mt-6 text-gray-600 text-lg">Loading partners...</p>
          </div>
        ) : error ? (
          <div className="text-center py-12">
            <p className="text-red-600 mb-6 text-lg">Error loading partners: {error}</p>
            <p className="text-gray-600">Please try again later.</p>
          </div>
        ) : partners.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {partners.map((partner) => (
              <PartnerLogo
                key={partner.id}
                name={partner.name}
                logo={partner.logo_url || "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=200&h=100&fit=crop"}
                description={partner.description || ""}
                website={partner.website_url || undefined}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-12 text-gray-500">
            <p className="text-xl mb-6">No partners available at this time.</p>
            <p className="text-lg">Check back soon for updates on our amazing partnerships!</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnersGrid;
